import React from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';

import Typography from '@material-ui/core/Typography';
import PriceSpecificationTable from 'common/PriceSpecification/PriceSpecificationTable';

const PurchasePaymentSpecification = ({ booking, purchaseItems }) => {
    const showVat = purchaseItems.some(o => o.vat);

    return (
        <>
            <Typography variant="h6" gutterBottom>{strings.specification}</Typography>
            <PriceSpecificationTable purchaseItems={purchaseItems} currency={booking.currency} showVat={showVat} />
        </>
    );
};

PurchasePaymentSpecification.propTypes = {
    booking: PropTypes.object.isRequired,
    purchaseItems: PropTypes.array.isRequired
};

export default PurchasePaymentSpecification;
